// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__aoOk_","col":"styles_col__u6Qa6","fulfillmentStatus":"styles_fulfillmentStatus__3oRKI","emailCol":"styles_emailCol__2r8dx"};